var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProTipsArrowDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40313 3.02323C11.0802 3.57667 13.51 6.69819 15.2255 8.7096C15.5016 9.04199 15.7861 9.37708 16.0596 9.71884C16.4472 10.1444 16.7441 10.6598 16.9293 11.2291C17.0637 11.7889 17.0051 12.3878 16.7646 12.9116C16.6417 13.1805 16.4853 13.4298 16.3001 13.6522C16.1389 13.902 15.9619 14.1392 15.7704 14.3619L15.3732 14.8279L15.0229 15.2578C14.79 15.5309 14.5806 15.8523 14.3477 16.1255C14.1149 16.3987 13.9022 16.6986 13.6713 16.9316C13.5535 17.0666 13.4288 17.194 13.2977 17.3132C13.1756 17.4405 13.0469 17.5598 12.9123 17.6707C12.3789 18.1344 9.78174 20.6179 9.14464 20.8712L8.86626 20.9769C8.51284 21.0417 8.15246 20.9692 7.84728 20.7719C7.5421 20.5746 7.31132 20.2649 7.19469 19.8962C7.04715 19.6376 6.98575 19.3293 7.02083 19.0229C7.05592 18.7164 7.18531 18.4303 7.3874 18.2124C7.93556 17.8057 13.9928 12.5055 13.4527 11.7296L13.1505 11.3584C11.4749 9.27792 9.4833 7.76941 7.59945 5.97272C7.31253 5.75362 7.11814 5.41701 7.0585 5.03602L7.00725 4.72388C6.97835 4.4045 7.03626 4.08091 7.17366 3.79393C7.31107 3.50696 7.52181 3.26943 7.77933 3.11134C7.9734 3.00441 8.19364 2.97329 8.40313 3.02323Z",
    fill: "#003764"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProTipsArrowDisabled);
export default __webpack_public_path__ + "static/media/pro-tips-arrow-disabled.4ec0320424dbe86bae50d1130a6e208d.svg";
export { ForwardRef as ReactComponent };